import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';

Component('tr-repository-sortable-tree', {
  mixins: [eventListenerMixin],

  properties: {
    repositoryGid: {
      type: String,
    },
  },

  connected() {
    this.tree = this.querySelector('tr-tree');
    this.listenTo(this, 'tr-tree:sorted', this.handleSorted.bind(this));
  },

  handleSorted(e) {
    const { item, targetList } = e.detail;
    const parent = closest(targetList, '.tr-tree-item');
    const gid = parent
      ? parent.querySelector('.repository-tree-node').dataset.gid
      : this.repositoryGid;

    window.$.ajax({
      url: `${item.querySelector('.repository-tree-node').dataset.url}?silent=true`,
      type: 'post',
      dataType: 'script',
      data: {
        'tr_repository_movement[position]': Array.prototype.slice
          .call(targetList.children)
          .indexOf(item),
        'tr_repository_movement[parent_gid]': gid,
      },
    });
  },

  disconnected() {
    document.querySelector('tr-repository-nav').update();
    this.stopListening();
  },
});
